module.exports = __webpack_public_path__ + "img/submitSuccess.d2aa2c0f.png";